// Telika Theme - Modular AJAX Cart Functionality

document.addEventListener('DOMContentLoaded', function () {
  // Initialize AJAX Add to Cart (Product Page form)
  initProductFormAddToCart();

  // Initialize AJAX Add to Cart (Quick-add cards)
  initAjaxAddToCart();

  // Initialize AJAX functionality on the Cart page
  initCartPageAJAX();
  
  // Set initial count
  updateCartCount();
});

// 1. AJAX Add to Cart — Product Page main form (Smooth conversion boost)
function initProductFormAddToCart() {
  const form = document.querySelector('form.product-form');
  if (!form) return;

  form.addEventListener('submit', function (e) {
    // If browser supports native form action or if JavaScript has failed elsewhere, fallback natively.
    e.preventDefault();

    const submitBtn = form.querySelector('button[type="submit"]');
    const variantId = form.querySelector('[name="id"]').value;
    const quantity = parseInt(form.querySelector('[name="quantity"]').value) || 1;

    // Fetch product details for the toast
    const productTitle = document.querySelector('.product-details-title')?.innerText || 'Produkt';
    const firstImage = document.querySelector('.main-image-slide img')?.src || '';

    // Show loading state
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.classList.add('is-loading');
      submitBtn.textContent = 'Duke u shtuar...';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    })
    .then(res => {
      if (!res.ok) throw new Error('Cart add failed');
      return res.json();
    })
    .then(item => {
      // Success
      // Fire Meta Pixel AddToCart (Deduplicated with eventID)
      if (item) {
        var cleanVarId = String(item.variant_id || item.id || '').replace(/[^0-9]/g, '');
        var atcEventId = (typeof window.generateMetaEventId === 'function')
          ? window.generateMetaEventId('atc')
          : ('atc_' + Date.now() + '_' + Math.random().toString(36).substring(2, 7));
        var atcData = {
          content_ids: cleanVarId ? [cleanVarId, 'shopify_' + cleanVarId] : ['shopify-' + (item.product_id || '')],
          content_type: 'product',
          value: parseFloat(item.price || '0') / 100,
          currency: 'EUR',
          content_name: (item.product_title || '').substring(0, 100)
        };
        if (typeof window.sendTelikaMetaEvent === 'function') {
          window.sendTelikaMetaEvent('AddToCart', atcData, null, atcEventId);
        } else if (typeof fbq === 'function') {
          fbq('track', 'AddToCart', atcData, { eventID: atcEventId });
        }
      }
      if (submitBtn) {
        submitBtn.classList.remove('is-loading');
        submitBtn.classList.add('is-added');
        submitBtn.textContent = 'Shtuar me Sukses! ✓';
        
        setTimeout(() => {
          submitBtn.disabled = false;
          submitBtn.classList.remove('is-added');
          submitBtn.textContent = 'SHTO NË SHPORTË';
        }, 3000);
      }

      // Update cart count and dropdown
      updateCartCount();
      if (typeof updateCartDropdown === 'function') {
        updateCartDropdown();
      }

      // Show toast
      if (typeof showCartToast === 'function') {
        showCartToast(productTitle, '/cart', firstImage);
      }
    })
    .catch(err => {
      console.error('AJAX Cart error:', err);
      // Fallback: Submit form natively
      form.submit();
    });
  });
}

// 2. AJAX Add to Cart (Quick-add from product cards)
function initAjaxAddToCart() {
  // Create global toast container if it doesn't exist
  if (!document.getElementById('ajax-cart-toast')) {
    const toastContainer = document.createElement('div');
    toastContainer.id = 'ajax-cart-toast';
    document.body.appendChild(toastContainer);
  }

  // Use event delegation so it works for dynamically loaded cards too
  document.addEventListener('submit', function(e) {
    const form = e.target.closest('.quick-add-form');
    if (!form) return;

    e.preventDefault();

    const btn = form.querySelector('button[type="submit"]');
    const variantId = form.querySelector('input[name="id"]').value;
    const quantity = parseInt(form.querySelector('input[name="quantity"]').value) || 1;

    const productTitle = form.dataset.productTitle || 'Produkt';
    const productUrl   = form.dataset.productUrl   || '/';
    const productImage = form.dataset.productImage  || '';

    // Loading state
    if (btn) {
      btn.classList.add('is-loading');
      btn.disabled = true;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    })
    .then(res => {
      if (!res.ok) throw new Error('Cart add failed: ' + res.status);
      return res.json();
    })
    .then(item => {
      // Success — update button state
      if (btn) {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        btn.disabled = false;

        const defaultSpan = btn.querySelector('.btn-text-default');
        const addedSpan   = btn.querySelector('.btn-text-added');
        if (defaultSpan) defaultSpan.style.display = 'none';
        if (addedSpan)   addedSpan.style.display   = '';

        // Reset button after 5 seconds
        setTimeout(() => {
          btn.classList.remove('is-added');
          if (defaultSpan) defaultSpan.style.display = '';
          if (addedSpan)   addedSpan.style.display   = 'none';
        }, 5000);
      }

      // Show toast notification
      showCartToast(productTitle, productUrl, productImage);

      // Fire Meta Pixel & CAPI AddToCart event for quick-add (Deduplicated with eventID)
      if (item) {
        var atcQuickEventId = (typeof window.generateMetaEventId === 'function')
          ? window.generateMetaEventId('atc')
          : ('atc_' + Date.now() + '_' + Math.random().toString(36).substring(2, 7));
        var atcQuickData = {
          content_ids: ['shopify-' + (item.product_id || item.id || '')],
          content_type: 'product',
          value: (parseFloat(item.price || '0') / 100) * quantity,
          currency: 'EUR',
          content_name: (item.product_title || productTitle || '').substring(0, 100)
        };
        if (typeof window.sendTelikaMetaEvent === 'function') {
          window.sendTelikaMetaEvent('AddToCart', atcQuickData, null, atcQuickEventId);
        } else if (typeof fbq === 'function') {
          fbq('track', 'AddToCart', atcQuickData, { eventID: atcQuickEventId });
        }
      }

      // Update cart count in header and dropdown
      updateCartCount();
      updateCartDropdown();
    })
    .catch(err => {
      console.error('AJAX Cart Error:', err);
      if (btn) {
        btn.classList.remove('is-loading');
        btn.disabled = false;
      }
      // Fallback: native form submit so nothing breaks
      const nativeForm = document.createElement('form');
      nativeForm.method = 'POST';
      nativeForm.action = '/cart/add';
      const idInput = document.createElement('input');
      idInput.type = 'hidden'; idInput.name = 'id'; idInput.value = variantId;
      const qtyInput = document.createElement('input');
      qtyInput.type = 'hidden'; qtyInput.name = 'quantity'; qtyInput.value = quantity;
      nativeForm.appendChild(idInput);
      nativeForm.appendChild(qtyInput);
      document.body.appendChild(nativeForm);
      nativeForm.submit();
    });
  });
}

function showCartToast(title, url, imgSrc) {
  const container = document.getElementById('ajax-cart-toast');
  if (!container) return;

  const toast = document.createElement('div');
  toast.className = 'cart-toast';
  toast.innerHTML = `
    ${imgSrc ? `<img class="cart-toast-img" src="${imgSrc}" alt="${title}" loading="lazy">` : ''}
    <div class="cart-toast-body">
      <div class="cart-toast-label">✓ U Shtua në Shportë</div>
      <div class="cart-toast-title">${title}</div>
      <a href="/cart" class="cart-toast-action">Shko tek Shporta →</a>
    </div>
    <button class="cart-toast-close" aria-label="Mbyll">×</button>
  `;

  toast.querySelector('.cart-toast-close').addEventListener('click', () => dismissToast(toast));
  container.appendChild(toast);

  // Auto-dismiss after 4 seconds
  setTimeout(() => dismissToast(toast), 4000);
}

function dismissToast(toast) {
  if (!toast || toast.classList.contains('toast-exit')) return;
  toast.classList.add('toast-exit');
  toast.addEventListener('animationend', () => toast.remove(), { once: true });
}

// 3. Update Cart Bubble Count Dynamically
function updateCartCount() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const counts = document.querySelectorAll('.cart-count');
      counts.forEach(el => {
        el.textContent = cart.item_count;
        if (cart.item_count > 0) {
          el.classList.remove('visually-hidden');
        } else {
          el.classList.add('visually-hidden');
        }
      });
    });
}
window.updateCartCount = updateCartCount;

// 4. Update Cart Dropdown View
function updateCartDropdown() {
  const dropdown = document.querySelector('#header-cart-dropdown');
  if (!dropdown) return;

  const loadingEl = dropdown.querySelector('.dropdown-loading');
  const emptyEl = dropdown.querySelector('.dropdown-empty-state');
  const listEl = dropdown.querySelector('#header-cart-items');
  const totalsEl = dropdown.querySelector('#header-cart-totals');
  const subtotalEl = dropdown.querySelector('#header-cart-subtotal');

  if (loadingEl) loadingEl.style.display = 'block';
  if (emptyEl) emptyEl.style.display = 'none';
  if (listEl) listEl.style.display = 'none';
  if (totalsEl) totalsEl.style.display = 'none';

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      if (loadingEl) loadingEl.style.display = 'none';

      if (cart.items.length === 0) {
        if (emptyEl) emptyEl.style.display = 'block';
        return;
      }

      if (listEl) {
        listEl.style.display = 'flex';
        listEl.innerHTML = cart.items.map(item => {
          let formattedPrice = '€' + (item.price / 100).toFixed(2);
          if (typeof formatMoney === 'function') {
            formattedPrice = formatMoney(item.price);
          } else if (window.money_format) {
            formattedPrice = window.money_format.replace('{{amount}}', (item.price / 100).toFixed(2)).replace('{{ amount }}', (item.price / 100).toFixed(2));
          }

          const imageUrl = item.image ? item.image : '//cdn.shopify.com/s/images/admin/no-image-large.gif';
          return `
            <div class="dropdown-item" data-key="${item.key}" style="display: flex; gap: 0.8rem; align-items: center; border-bottom: 1px solid rgba(255, 255, 255, 0.05); padding-bottom: 0.8rem;">
              <a href="${item.url}" style="width: 50px; height: 50px; flex-shrink: 0; border: 1px solid rgba(255, 255, 255, 0.1); border-radius: 6px; overflow: hidden; background: #252525; display: flex; align-items: center; justify-content: center; text-decoration: none;">
                <img src="${imageUrl}" alt="${item.title}" style="max-width: 100%; max-height: 100%; object-fit: contain;">
              </a>
              <div style="flex-grow: 1; display: flex; flex-direction: column; gap: 0.2rem; min-width: 0; text-align: left;">
                <a href="${item.url}" style="font-size: 0.8rem; font-weight: 600; color: #FFFFFF; text-decoration: none; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; display: block; transition: var(--transition);">${item.product_title}</a>
                <span style="font-size: 0.75rem; color: var(--color-text-muted);">Sasia: ${item.quantity}</span>
                <span style="font-size: 0.8rem; color: var(--color-price); font-weight: 700;">${formattedPrice}</span>
              </div>
              <button class="remove-cart-dropdown-btn" data-key="${item.key}" style="background: none; border: none; color: #ef4444; cursor: pointer; padding: 0.2rem; font-size: 1.2rem; font-weight: 700; display: flex; align-items: center; justify-content: center; margin-left: auto;" title="Largo">×</button>
            </div>
          `;
        }).join('');
      }

      if (subtotalEl) {
        let formattedTotal = '€' + (cart.total_price / 100).toFixed(2);
        if (typeof formatMoney === 'function') {
          formattedTotal = formatMoney(cart.total_price);
        } else if (window.money_format) {
          formattedTotal = window.money_format.replace('{{amount}}', (cart.total_price / 100).toFixed(2)).replace('{{ amount }}', (cart.total_price / 100).toFixed(2));
        }
        subtotalEl.textContent = formattedTotal;
      }

      if (totalsEl) totalsEl.style.display = 'block';
    })
    .catch(err => {
      console.error('Error fetching cart dropdown:', err);
      if (loadingEl) loadingEl.style.display = 'none';
      if (emptyEl) emptyEl.style.display = 'block';
    });
}
window.updateCartDropdown = updateCartDropdown;

// 5. AJAX Cart Page Quantity/Remove Management
function initCartPageAJAX() {
  const cartForm = document.querySelector('.cart-form');
  if (!cartForm) return;
  bindCartPageAJAXEvents();
}

function bindCartPageAJAXEvents() {
  // Quantity Selector Buttons (+ / -)
  const qtyBtns = document.querySelectorAll('.js-cart-qty-change');
  qtyBtns.forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      const key = this.getAttribute('data-key');
      const qty = this.getAttribute('data-qty');
      if (key && qty !== null) {
        updateCartPageQuantityAJAX(key, qty);
      }
    });
  });

  // Remove Button (Largo ✕)
  const removeBtns = document.querySelectorAll('.js-cart-remove');
  removeBtns.forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      const key = this.getAttribute('data-key');
      if (key) {
        updateCartPageQuantityAJAX(key, 0);
      }
    });
  });
}

function updateCartPageQuantityAJAX(key, qty) {
  // Show loading indicator
  document.body.classList.add('cart-loading');

  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: key,
      quantity: parseInt(qty, 10)
    })
  })
  .then(res => {
    if (!res.ok) throw new Error('Cart change failed');
    return res.json();
  })
  .then(cart => {
    // Update header cart bubble dynamically
    updateCartCount();

    // Re-fetch the current cart page HTML and swap out only the cart-form
    return fetch(window.location.pathname + window.location.search);
  })
  .then(res => res.text())
  .then(html => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const newCartForm = doc.querySelector('.cart-form');
    const oldCartForm = document.querySelector('.cart-form');

    if (newCartForm && oldCartForm) {
      oldCartForm.replaceWith(newCartForm);
      // Re-bind all AJAX listeners to the newly injected elements
      bindCartPageAJAXEvents();
    } else {
      // Cart is empty, reload page to display Shopify's native empty state
      window.location.reload();
    }
  })
  .catch(err => {
    console.error('Error updating cart quantity AJAX:', err);
    window.location.reload(); // Fallback reload on error
  })
  .finally(() => {
    // Hide loading indicator
    document.body.classList.remove('cart-loading');
  });
}

// Meta Pixel & CAPI InitiateCheckout Tracking (Deduplicated with eventID)
document.addEventListener('click', function(e) {
  var target = e.target.closest('a[href*="/checkout"], button[name="checkout"], .btn-checkout, #checkout-button, .checkout-btn');
  if (target) {
    var icEventId = (typeof window.generateMetaEventId === 'function')
      ? window.generateMetaEventId('ic')
      : ('ic_' + Date.now() + '_' + Math.random().toString(36).substring(2, 7));
    var icData = {
      currency: 'EUR'
    };
    if (typeof window.sendTelikaMetaEvent === 'function') {
      window.sendTelikaMetaEvent('InitiateCheckout', icData, null, icEventId);
    } else if (typeof fbq === 'function') {
      fbq('track', 'InitiateCheckout', icData, { eventID: icEventId });
    }
  }
});
